import { Flex, spaces } from '@electricjs/arc';
import { ReactNode } from 'react';

type TableSearchBarProps = {
  search?: ReactNode;
  filters?: ReactNode;
  padding?: string | number;
  // Lets `filters` drop below `search` when the row runs out of space,
  // instead of squeezing both onto one line.
  wrap?: boolean;
};

const TableSearchBar = ({
  search,
  filters,
  padding = spaces.space_m,
  wrap = false,
}: TableSearchBarProps) => (
  <Flex
    width="100%"
    p={padding}
    alignItems="center"
    gap={spaces.space_m}
    flexWrap={wrap ? 'wrap' : undefined}>
    {search}
    {filters}
  </Flex>
);

export default TableSearchBar;
